import { render, staticRenderFns } from "./TypeCell.vue?vue&type=template&id=b936d1f8&scoped=true"
import script from "./TypeCell.vue?vue&type=script&lang=js"
export * from "./TypeCell.vue?vue&type=script&lang=js"
import style0 from "./TypeCell.vue?vue&type=style&index=0&id=b936d1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b936d1f8",
  null
  
)

export default component.exports